import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import OutboundLink from "./OutboundLink";
import classNames from "classnames";
import styles from "../styles/Footer.module.scss";
import { useState } from "react";

const Footer = () => {
  const [showDevInfo, setShowDevInfo] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.containerInner}>
        <div className={classNames("d-sm-none d-md-flex", styles.row, styles.vertical)}>
          <Link to="/about-us">About Us</Link>
          <Link to="/contact-us">Contact</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <div className={styles.row}>
          <OutboundLink ariaLabel="Facebook" url="https://www.facebook.com/EDHREC1" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-facebook" />
          </OutboundLink>
          <OutboundLink ariaLabel="Instagram" url="https://www.instagram.com/EDHREC" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-instagram" />
          </OutboundLink>
          <OutboundLink ariaLabel="RSS" url="https://edhrec.com/articles/feed/?cat=4" utm_medium="footer">
            <FontAwesomeIcon icon="rss-square" />
          </OutboundLink>
          <OutboundLink ariaLabel="TikTok" url="https://www.tiktok.com/@edhrec" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-tiktok" />
          </OutboundLink>
          <OutboundLink ariaLabel="Twitch" url="https://www.twitch.tv/EDHRECast" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-twitch" />
          </OutboundLink>
          <OutboundLink ariaLabel="Twitter" url="https://www.twitter.com/EDHREC" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-twitter" />
          </OutboundLink>
          <OutboundLink ariaLabel="YouTube" url="https://www.youtube.com/EDHRECast" utm_medium="footer">
            <FontAwesomeIcon icon="fa-brands fa-youtube" />
          </OutboundLink>
        </div>
        <div className={classNames("d-sm-none d-md-flex", styles.row, styles.vertical)}>
          <OutboundLink className={styles.scm} url="https://spacecowmedia.com/" utm_medium="footer">
            Space Cow Media
          </OutboundLink>
          <OutboundLink className="d-none d-md-flex" url="https://archidekt.com/" utm_medium="footer">
            Archidekt
          </OutboundLink>
          <OutboundLink className="d-none d-md-flex" url="https://commandersherald.com/" utm_medium="footer">
            Commander's Herald
          </OutboundLink>
          <OutboundLink className="d-none d-md-flex" url="https://commanderspellbook.com/" utm_medium="footer">
            Commander Spellbook
          </OutboundLink>
          <OutboundLink className="d-none d-md-flex" url="https://fabrec.gg/" utm_medium="footer">
            FABREC
          </OutboundLink>
          <OutboundLink className="d-none d-md-flex" url="https://spellvoid.com/" utm_medium="footer">
            Spellvoid
          </OutboundLink>
        </div>
        <div className={classNames("d-none d-sm-flex d-md-none", styles.row)}>
          <OutboundLink className={styles.scm} url="https://spacecowmedia.com/" utm_medium="footer">
            Space Cow Media
          </OutboundLink>
          <OutboundLink url="https://archidekt.com/" utm_medium="footer">
            Archidekt
          </OutboundLink>
          <OutboundLink url="https://commandersherald.com/" utm_medium="footer">
            Commander's Herald
          </OutboundLink>
        </div>
        <div className={classNames("d-none d-sm-flex d-md-none", styles.row)}>
          <OutboundLink url="https://commanderspellbook.com/" utm_medium="footer">
            Commander Spellbook
          </OutboundLink>
          <OutboundLink url="https://fabrec.gg/" utm_medium="footer">
            FABREC
          </OutboundLink>
          <OutboundLink url="https://spellvoid.com/" utm_medium="footer">
            Spellvoid
          </OutboundLink>
        </div>
        <div
          className={classNames(styles.devInfo, {
            "text-danger": showDevInfo && parseInt(process.env.REACT_APP_GIT_DIRTY) > 0,
            "text-success": showDevInfo,
            [styles.hidden]: !showDevInfo,
          })}
          onClick={() => setShowDevInfo(true)}
        >
          {process.env.REACT_APP_GIT_COMMIT}
        </div>
        <div className={styles.row}>
          <b>Exclusive Member of Mediavine Home</b>
        </div>
      </div>
    </div>
  );
};

export default Footer;
